import React from "react";
import { Carousel } from "react-bootstrap";
import "./AboutMe.css";

const AboutMe = () => {
  return (
    <div className="about">
      <div className="row aboutMeDetail">
        <div className="col-md-5 col-12">
          <img
            className="about-img"
            src="https://i.ibb.co/QkSVTRj/istockphoto-1290492381-170667a.png"
            alt=""
          />
        </div>
        <div className="col-md-7 col-12">
          <h3 className="about-header">About Myself</h3>
          <p className="text-light">
            Hello, I'm Iasir Arafat Riaz, I finished my graduation BSC in
            Computer Science and engineering from University of Liberal Arts
            Bangladesh (ULAB). After finishing graduation i started a start-up
            business in 2017, eventually 2020 in covid pandemic i faced huge
            challenge and finally i quit my business and go back my computer
            science origin, then again started new journey with web. then
            exploring web development with self motivation and dedication. I am
            a Junior Web Developer also fresher in MERN stack. I am an ambitious
            problem solver with a passion. I have experience in team project, I
            successfully finished a fullstack team project, here i was team
            leader. Also I have finished some project with modern web
            technology. I am a self-motivated IT professional with strong
            proficiency in ReactJS, JavaScript,Tailwind, Bootstrap, CSS, HTML,
            NodeJS, Express, MongoDB and especially mobile responsive web
            development alongside the ability in writing DRY and efficient code.
            Programming is my passion. Traveling with motor bike is my hobby. I
            love to play cricket. I am a foodies also. I can do my best what i
            love to do. Please check my projects, so you can get a proper
            concept about my work. I hope i will be able to earn your trust upon
            me. I have a keen interest in technology. I am continually
            evaluating and upgrading my skills so that I can stay at the cutting
            edge of web development.
          </p>
        </div>
      </div>
      <br />
      <br />
      <br />
      <div className="row aboutMeDetail">
      <div className="col-md-6 col-12">
          <h3 className="about-header">Entrepreneur Of The Year</h3>
          <p className="text-light">
            On 7th december in 2019 i received award Entrepreneur Of The Year from Zunaid Ahmed Palak ( Minister of State for Information and Communication Technology Division, Bangladesh), Also present in stage Adnan Imtiaz Halim (Founder and CEO at Sheba Platform LTD), Mominul Islam (Managing Director and CEO at IPDC)  That event organized by Sheba.xyz and IPDC. I also worked with Sheba Platform Limited. I was a Co-founder of Rapid Movers. I was developing relocation service in our country and provide hassle fre professional service also work for digitalization relocation service. My company served well known giant company in bangladesh.
          </p>
        </div>
        <div className="col-md-6 col-12">
          <Carousel>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://i.ibb.co/ypx9xTZ/aw.png"
      alt="First slide"
    />
 
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://i.ibb.co/THTxnzm/award2.png"
      alt="Second slide"
    />

  
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://i.ibb.co/jWvk1yZ/award3.png"
      alt="Third slide"
    />

   
  </Carousel.Item>
</Carousel>

         
        </div>
        
      </div>
      
      <div className="row">
        <div className="col-md-6 col-12"></div>
        <div className="col-md-6 col-12"></div>
      </div>
    </div>
  );
};

export default AboutMe;

//thanks
